/*
 * Trade application page (see sections/ud-trade-application.liquid).
 * - puts first + last name into the form's name field and stamps the date and time when it is sent
 * - remembers the business name for this tab so the thank-you page can build the resale certificate email
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-udt]');
  if (!root) return;

  var KEY = 'udTradeBusiness';

  var done = root.querySelector('[data-udt-done]');
  if (done) {
    try {
      done.focus();
    } catch (e) {}

    var link = root.querySelector('[data-udt-mailto]');
    var business = '';
    try {
      business = window.sessionStorage.getItem(KEY) || '';
    } catch (e) {}
    if (link && business) {
      var address = root.getAttribute('data-udt-email') || '';
      var subject = 'Trade application: resale certificate (' + business + ')';
      link.setAttribute('href', 'mailto:' + address + '?subject=' + encodeURIComponent(subject));
    }
    return;
  }

  var form = root.querySelector('form');
  if (!form) return;

  var first = form.querySelector('[data-udt-first]');
  var last = form.querySelector('[data-udt-last]');
  var name = form.querySelector('[data-udt-name]');
  var at = form.querySelector('[data-udt-at]');
  var biz = form.querySelector('[data-udt-business]');

  // Eastern time for reading, UTC for the record (same format as the furniture agreement).
  function stamp() {
    var now = new Date();
    var human;
    try {
      human = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      }).format(now);
    } catch (e) {
      human = now.toString();
    }
    return human + ' / ' + now.toISOString().replace(/\.\d+Z$/, 'Z');
  }

  form.addEventListener('submit', function () {
    if (name && first && last) name.value = (first.value + ' ' + last.value).trim();
    if (at) at.value = stamp();
    if (biz) {
      try {
        window.sessionStorage.setItem(KEY, biz.value.trim().slice(0, 80));
      } catch (e) {}
    }
  });
})();
